import { isEqual } from 'lodash-es';

import { insertInArrayByIndex } from '@editor2/services/helpersService';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { pageGroupToPageGroupProperties } from '@editor2/mappers/pageGroup';

import {
	addStatus,
	deleteProperty,
	isEqualIdsArrays,
	removeStatus,
	renumberChapterPages
} from './helpers';
import { deletePageFromPageGroupHelper } from './pagesAdapter';

export const addPageGroupToChapterHelper = (state, payload) => {
	const { chapterId, pageGroupEntity, index } = payload;
	const chapter = state.chapters.entities[chapterId];
	const ind = index !== undefined ? index : chapter.page_groups.length;

	const pageGroupsIds = insertInArrayByIndex(chapter.page_groups, pageGroupEntity.family_id, ind);

	state.page_groups.entities[pageGroupEntity.family_id] = pageGroupEntity;
	state.page_groups.ids.push(pageGroupEntity.family_id);

	state.chapters.entities[chapterId].page_groups = pageGroupsIds;

	state.changes.page_groups[pageGroupEntity.family_id] = [ChangesStatus.New];
	state.changes.chapters[chapterId] = addStatus(
		state.changes.chapters[chapterId],
		ChangesStatus.ChildrenReorder
	);

	return state;
};

export const movePageGroupHelper = (state, payload) => {
	const { sourceDroppableId, destinationDroppableId, pageGroupId, destinationIndex } = payload;

	const initSourcePageGroups =
		state.initialCourse.chapters.entities[sourceDroppableId]?.page_groups || [];
	const sourcePageGroups = state.chapters.entities[sourceDroppableId].page_groups.filter(
		(id) => id !== pageGroupId
	);

	const initDestinationPageGroups =
		state.initialCourse.chapters.entities[destinationDroppableId]?.page_groups || [];
	const destinationGroups =
		sourceDroppableId === destinationDroppableId
			? sourcePageGroups
			: state.chapters.entities[destinationDroppableId].page_groups;
	const destinationPageGroups = insertInArrayByIndex(
		destinationGroups,
		pageGroupId,
		destinationIndex
	);
	state.chapters.entities[sourceDroppableId].page_groups = sourcePageGroups;
	state.chapters.entities[destinationDroppableId].page_groups = destinationPageGroups;

	const isSourceEqual = isEqualIdsArrays(initSourcePageGroups, sourcePageGroups);
	const isDestinationEqual = isEqualIdsArrays(initDestinationPageGroups, destinationPageGroups);

	state.changes.chapters[sourceDroppableId] = isSourceEqual
		? removeStatus(state.changes.chapters[sourceDroppableId], ChangesStatus.ChildrenReorder)
		: addStatus(state.changes.chapters[sourceDroppableId], ChangesStatus.ChildrenReorder);

	state.changes.chapters[destinationDroppableId] = isDestinationEqual
		? removeStatus(state.changes.chapters[destinationDroppableId], ChangesStatus.ChildrenReorder)
		: addStatus(state.changes.chapters[destinationDroppableId], ChangesStatus.ChildrenReorder);

	renumberChapterPages(state, state.chapters.entities[sourceDroppableId]);
	renumberChapterPages(state, state.chapters.entities[destinationDroppableId]);

	return state;
};

export const deletePageGroupFromChapterHelper = (state, payload) => {
	const { chapterId, pageGroupId } = payload;

	const initialPageGroupsIds = state.initialCourse.chapters.entities[chapterId]?.page_groups || [];
	const pageGroupsIds = state.chapters.entities[chapterId].page_groups.filter(
		(id) => id !== pageGroupId
	);

	// remove children
	state.page_groups.entities[pageGroupId].pages.map((pageId) => {
		deletePageFromPageGroupHelper(state, { pageGroupId, pageId });
	});

	state.chapters.entities[chapterId].page_groups = pageGroupsIds;
	state.page_groups.entities = deleteProperty(state.page_groups.entities, pageGroupId);

	const isNew = state.changes.page_groups[pageGroupId]?.includes(ChangesStatus.New);

	state.changes.page_groups[pageGroupId] = isNew ? [] : [ChangesStatus.Deleted];
	state.changes.chapters[chapterId] = isEqualIdsArrays(initialPageGroupsIds, pageGroupsIds)
		? removeStatus(state.changes.chapters[chapterId], ChangesStatus.ChildrenReorder)
		: addStatus(state.changes.chapters[chapterId], ChangesStatus.ChildrenReorder);

	renumberChapterPages(state, state.chapters.entities[chapterId]);

	return state;
};

export const updatePageGroupHelper = (state, payload) => {
	const { pageGroupId, ...pageGroup } = payload;

	const initialPageGroup = state.initialCourse.page_groups.entities[pageGroupId];
	const updatedPageGroup = { ...state.page_groups.entities[pageGroupId], ...pageGroup };

	const attributesEqual = initialPageGroup
		? isEqual(
				pageGroupToPageGroupProperties(initialPageGroup),
				pageGroupToPageGroupProperties(updatedPageGroup)
		  )
		: false;

	state.page_groups.entities[pageGroupId] = updatedPageGroup;

	state.changes.page_groups[pageGroupId] = attributesEqual
		? removeStatus(state.changes.page_groups[pageGroupId], ChangesStatus.Modified)
		: addStatus(state.changes.page_groups[pageGroupId], ChangesStatus.Modified);

	return state;
};
